var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAudioOn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39674 21.9351H1C0.447715 21.9351 0 21.4874 0 20.9351V12.9351C0 12.3828 0.447715 11.9351 1 11.9351H8C8.11267 11.9351 8.22098 11.9537 8.32203 11.9881L17.7847 2.30316C18.4113 1.66191 19.5 2.1055 19.5 3.00201L19.5 31.8682C19.5 32.7647 18.4113 33.2083 17.7847 32.5671L7.39674 21.9351Z",
    fill: "#3B3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 28.6344C27.6608 26.987 31 22.5421 31 17.3172C31 12.0923 27.6608 7.64735 23 6V8.14926C26.5318 9.69238 29 13.2165 29 17.3172C29 21.4178 26.5318 24.942 23 26.4851V28.6344Z",
    fill: "#3B3B3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 34.5929C31.5086 32.4262 37 25.5027 37 17.2965C37 9.09028 31.5086 2.16669 24 0V2.09322C30.3879 4.19281 35 10.206 35 17.2965C35 24.3869 30.3879 30.4001 24 32.4997V34.5929Z",
    fill: "#3B3B3B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAudioOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AudioOn.a2ecd947c99b77dd77ec2ec61fc3b2d7.svg";